import React, { Component } from "react";
import ReactDOM from 'react-dom'; 
import { LangContext } from "../LangContext.jsx";

class TextFieldsValidation extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            options:[],
            conditions: [],
        };
    }

    handleAgregarCondicion = (e) => {
        e.preventDefault();  
        const primerElemento = this.state.options[0].param;

        const nuevaCondicion = { param1: primerElemento, param2: ''  };

        this.setState((prevState) => ({
            conditions: [...prevState.conditions, nuevaCondicion],
          }), () => {
            this.updateValidationState();
        });
      };

      handleEliminarCondicion = (index, e, param,description) => {
        e.preventDefault();  
        this.setState((prevState) => {
            const newConditions = prevState.conditions.filter((_, i) => i !== index); 
            const newOptions = [{ param: param }, ...prevState.options]; // Agregar al principio
            return {
                conditions: newConditions,
                options: this.state.options,
            };
        }, () => { 
            this.updateValidationState();
        });
    };
    

    handleCondicionChange = (index, campo, valor) => {   
        this.setState((prevState) => {
            const nuevasCondiciones = [...prevState.conditions];
            nuevasCondiciones[index][campo] = valor;
            return { conditions: nuevasCondiciones };
        },function(){
            
        }); 
        this.updateValidationState()
    };
 
    updateValidationState = () => { 
        const allChildStates = { ...this.state }; 
        this.props.updateValidationState(allChildStates);
    }
    componentDidMount() {  
    	if (this.props.conditions) {
        let nc = this.props.conditions.map(condition=>{
          return {
          ...condition,
          param2: condition.value,
          param1: condition.internal_validation_id,
          };
      }) 
      if (this.props.conditions != null) {
          this.setState({
            conditions: nc, 
          },function(){
            this.updateValidationState() 
          })
      }}
      const { lang } = this.context;
      const updatedOptions = [{
        param: '4',
        description: lang.get('messages.contiene')
      },{
        param:'5',
        description: lang.get('messages.no_contiene')
      },{
        param:'6',
        description:lang.get('messages.igual_al_rfc_del_invitado')
      },{
        param:'7',
        description:lang.get('messages.igual_a_la_razon_social__nombre')
      },{
        param:'8',
        description:lang.get('messages.igual_al_cp_edo_pais_ciudad')
      },{
        param:'9',
        description:lang.get('messages.numero_de_caracteres')
      }];
  
      this.setState({
        options: updatedOptions
      });
    }
    render() {
      const { lang } = this.context; 
        return (
            <div> 
				{this.state.conditions.map((condition, index) => (
				<div key={index} className="d-flex align-items-center mt-3">
					<div  className="col-md-4" >Campo: {this.props.fieldName} </div>
					<select
					className="form-control"
					value={condition.param1.toString()}
					onChange={(e) => this.handleCondicionChange(index, 'param1', e.target.value)}
					>
					{this.state.options.map((option) => (
						<option key={option.param} value={option.param}>
						{option.description}
						</option>
					))}
					</select> 
					{condition.param1 != '6' && condition.param1 != '7' && condition.param1 != '8' && (
					<input
						className="form-control col-md-5"
						type="text"
						value={condition.param2}
						onChange={(e) => this.handleCondicionChange(index, 'param2', e.target.value)}
					/>
					)} 
					<span onClick={(e) => this.handleEliminarCondicion(index, e,condition.param1,condition.description)} className="flaticon2-cross mx-2" style={{ color: '#844AFF' }}></span> 
					
				</div>
				))}
				<div className="d-flex align-items-center cursor-pointer">
					<span className="mt-3 text-primary" onClick={this.handleAgregarCondicion}> <small className="flaticon2-plus text-primary"></small> {lang.get('messages.agregar_nueva_condicion')}</span>
				</div>
			</div>
        );
    }
}

export default TextFieldsValidation;

if (document.getElementById('TextFieldsValidation')) {
    ReactDOM.render(<TextFieldsValidation />, document.getElementById('TextFieldsValidation'));
}
